import { Text } from './Text'

interface Props {
  reference: string
  children: React.ReactNode
  url?: string
}

export default function BibleVerse({ reference, url, children }: Props) {
  return (
    <div className='flex flex-col gap-6 bg-[#9103B7]/5 border-l-[8px] border-l-[#9103B7] py-[24px] px-[36px] rounded-r-[12px]'>
      <Text.Verse className='text-[#9103B7] font-medium'>
        {children} —{' '}
        <a
          href={url}
          className='text-[#007AFF] hover:border-b-2 hover:border-[#007AFF] transition-all'
          target='_blank'
          rel='noreferrer'
        >
          {reference}
        </a>
      </Text.Verse>
    </div>
  )
}
